import { Creator, OperationsSlice } from 'store/types';

export const createOperationsSlice: Creator<OperationsSlice> = (set) => ({
  hoveredDate: undefined,
  hoveredData: undefined,
  prevStateDate: undefined,
  setPrevStateDate: (date: Date | undefined) =>
    set(() => ({ prevStateDate: date })),
  setHoveredDate: (date: Date | undefined) =>
    set((prev) => ({
      hoveredDate:
        +(date ?? 0) === +(prev.hoveredDate ?? 0) ? prev.hoveredDate : date,
    })),
  nowMode: false,
  setNowMode: (on: boolean) => set(() => ({ nowMode: on })),
});
